import { __exportAll } from "./_virtual/_rolldown/runtime.js";
import "./loyalty_auth_method.js";
//#region src/loyalty_auth_method_helper.ts
var loyalty_auth_method_helper_exports = /* @__PURE__ */ __exportAll({
	name: () => name,
	usesEmail: () => usesEmail,
	usesPhone: () => usesPhone
});
function name(loyaltyAuthMethod) {
	switch (loyaltyAuthMethod) {
		case 1: return "Scanned Barcode";
		case 2: return "Email + Phone Number";
		case 3: return "Email + Password";
		case 4: return "Username + Password";
		case 5: return "Phone Number";
		case 6: return "Card Number";
		case 7: return "Email";
		case 8: return "Web Session Token";
		case 9: return "Manual Redemption";
		case 10: return "HID";
	}
}
function usesEmail(loyaltyAuthMethod) {
	switch (loyaltyAuthMethod) {
		case 7:
		case 3:
		case 2: return true;
		case 1:
		case 6:
		case 5:
		case 4:
		case 8:
		case 9:
		case 10: return false;
	}
}
function usesPhone(loyaltyAuthMethod) {
	switch (loyaltyAuthMethod) {
		case 2:
		case 5: return true;
		case 1:
		case 6:
		case 7:
		case 3:
		case 4:
		case 8:
		case 9:
		case 10: return false;
	}
}
//#endregion
export { loyalty_auth_method_helper_exports, name, usesEmail, usesPhone };

//# sourceMappingURL=loyalty_auth_method_helper.js.map